module.exports = __webpack_public_path__ + "img/24.d8f5df03.png";